import React, { Component } from 'react';
import './App.css';
import Navbar from './component/navbar/navbar';
import Footer from './component/footer/footer';
import Main from './component/main/main';
import Seo from './component/seo/seo';
import AdSenseLoader from './component/adsense/adSenseLoader';
import AdUnit from './component/adsense/adUnit';

class App extends Component {

    render() {
        return(
            <div className="App">
                <Seo />
                <AdSenseLoader />
                <header>
                    <Navbar/>
                </header>
                <main className="container-fluid" id="main-content">
                    <Main/>
                    <AdUnit slotKey="aboveFooter" className="adsense-above-footer" />
                </main>
                <Footer/>
            </div>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js